module.exports = __webpack_public_path__ + "static/media/easi6_rental_ko.24501785.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/easi6_rental_ko.md
// module id = 60
// module chunks = 0